import { gql } from '@apollo/client';
import _ from 'lodash';
import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import { CREATION_ID } from '../../editor/editorSlice';
import type { CommentThreadMinimized_ThreadFragment } from '../../graphql/generated/graphqlTypes';
import CommentThreadCompactAvatarStack from './CommentThreadCompactAvatarStack';

export const MINIMIZED_COMMENT_HEIGHT = 34;

const THREAD_FRAGMENT = gql`
  fragment CommentThreadMinimized_thread on PublicThreadFields {
    id
    comments {
      id
      ...CommentThreadCompactAvatarStack_comment
    }
  }
  ${CommentThreadCompactAvatarStack.fragments.comment}
`;

interface CommentThreadMinimizedProps {
  thread: CommentThreadMinimized_ThreadFragment;
}

const CommentThreadMinimized = ({ thread }: CommentThreadMinimizedProps) => {
  const currentUser = useAppSelector((state) => state.session.user);
  // TODO: Remove `threadComments` after upgrading to TypeScript 5.2.
  const threadComments: {
    author: { id: string; name: string };
  }[] = thread.comments;
  const author =
    thread.id === CREATION_ID
      ? currentUser
      : _.get(_.first(threadComments), 'author');

  return author ? (
    <CommentThreadCompactAvatarStack
      comments={[{ id: author.id, author }]}
      ring={false}
    />
  ) : null;
};

CommentThreadMinimized.fragments = { thread: THREAD_FRAGMENT };

export default CommentThreadMinimized;
